import React from "react"
import {FieldViewSize} from "../../../../../const"

type Props = {
    option          : any

    size?           : FieldViewSize
    disabled?       : boolean   // the read only value - no hover border, no toggle arrow
    className?      : string
    labelClassName? : string    // the class of the type name - ui5-txt-default when not set
    onClick?        : callback
    children?       : any   // used for popovers etc
}

/**
 * The contact type reads as a color box plus the plain type name - no pill. The inline editable
 * renders it for both the empty and the filled value.
 *
 * GOTCHA: the box around it (transparent border, dashed on hover, the toggle arrow) comes from
 * .ui5-field-dropdown-inline-editable - without that class the value has no border and does not read
 * as an inline dropdown. The class also reacts to the 'show-popover' the editable adds to className,
 * and keeps the box but drops the hover border and the arrow when the value is 'disabled'.
 */
export default function FieldCrmContactType_Value(props: Props) {

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)

    const classes = Classes("ui5-field-dropdown-inline-editable", props.className, {
        'size-small' : size === FieldViewSize.SMALL,
        'disabled'   : !!props.disabled
    })

    const color = _.get(props.option, 'color', null)

    const labelClasses = Classes(props.labelClassName || "ui5-txt-default", "txt-truncate m-b-2")

    return (
        <>
            <div className  = {classes}
                 onClick    = {props.onClick}
            >
                {!_.isNil(color) &&
                    <div className={Classes("ui5-color-box m-r-8", "gd-c-{0}".f(color))}/>}

                {/* m-b-2 lifts the text 1px against the color box - see FieldDropdown_ValueNotEmpty */}
                <div className={labelClasses}>
                    {_.get(props.option, 'label', '')}
                </div>
            </div>
            {props.children}
        </>
    )
}
